export const currentView = state => state.currentView;
